import React from "react";

// Individual Card Component
const LandingPageCard = ({
  title,
  description,
  imageUrl = "/api/placeholder/400/200",

  isExternal = false,
}) => {
  const styles = {
    card: {
      width: "100%",
      backgroundColor: "white",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
      border: "1px solid #e0e0e0",
      fontFamily: "Arial, sans-serif",
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    imageContainer: {
      backgroundColor: "#fff0f3",
      width: "100%",
    },
    image: {
      width: "100%",
      height: "160px",
      objectFit: "cover",
      display: "block",
    },
    contentSection: {
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
    },
    title: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "8px",
      marginTop: "0",
    },
    description: {
      fontSize: "14px",
      color: "#444",
      lineHeight: "1.4",
      marginBottom: "16px",
      flexGrow: 1,
    },
    buttonContainer: {
      display: "flex",
      gap: "8px",
      marginTop: "auto",
    },
    primaryButton: {
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#3b82f6",
      backgroundColor: "transparent",
      border: "1px solid #3b82f6",
      borderRadius: "4px",
      cursor: "pointer",
    },
    secondaryButton: {
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#16a34a",
      backgroundColor: "transparent",
      border: "1px solid #16a34a",
      borderRadius: "4px",
      cursor: "pointer",
    },
    externalLink: {
      marginTop: "auto",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    externalButton: {
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#6366f1",
      backgroundColor: "transparent",
      border: "1px solid #6366f1",
      borderRadius: "4px",
      cursor: "pointer",
      textAlign: "center",
      width: "100%",
    },
  };

  return (
    <div style={styles.card}>
      <div style={styles.imageContainer}>
        <img
          src={imageUrl}
          alt={`${title} illustration`}
          style={styles.image}
        />
      </div>

      <div style={styles.contentSection}>
        <h2 style={styles.title}>{title}</h2>
        <p style={styles.description}>{description}</p>
      </div>
    </div>
  );
};

// Course data from the provided information
const coursesData = [
  {
    title: "MRCP Part 1",
    description:
      "Over 4,900 Single Best Answer questions. Also includes the innovative Knowledge Tutor which tests you on thousands of high-yield facts",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055894/image1_heidwf.jpg",
  },
  {
    title: "MRCGP Applied Knowledge Test",
    description:
      "Over 4,500 Single Best Answer and Extended Matching Question for the new style Applied Knowledge Test (AKT). Also includes the Knowledge tutor for revision of high-yield facts",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055905/image2_cb98yi.jpg",
  },
  {
    title: "Medical student finals / UKMLA resource",
    description:
      "Over 10,000 Single Best Answer questions for medical finals and the UKMLA. Also included is the OSCE resource & Prescribing Skills Assessment questions",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055897/image3_a0p3zs.jpg",
  },
  {
    title: "MRCP Part 2 Written",
    description:
      "Over 2,600 single best answer (SBA) questions for the MRCP Part 2 Written Examination. Features questions covering the whole of the UK Specialty Training Curriculum for Core Medical Training.",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055901/image4_fkv5vf.jpg",
  },
  {
    title: "2025 Multi-Specialty Recruitment Assessment (MSRA)",
    description:
      "Previously known as the GP ST Stage 2 exam. Over 2,900 questions for the Clinical Problem Solving paper and 300 Professional Dilemma questions of both types.",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055906/image5_th9wib.jpg",
  },
  {
    title: "Medical student years 1-3",
    description:
      "Our Years 1-3 resource is aimed at students in the early years of medical school. Over 4,700 SBA questions and an extensive ANKI-style knowledge tutor to help you learn the basics of medicine",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055909/image6_fku0s0.jpg",
  },
  {
    title: "DRCOG",
    description: "Over 1,000 Single Best Answer questions for the DRCOG",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055900/homepage_zugcrp.jpg",
  },
  {
    title: "PLAB Part 1",
    description:
      "Over 5,000 questions for the PLAB Part 1 exam (plus a full gold-standard mock exam) and CPSA resources for the PLAB Part 2",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055902/image8_qervx7.jpg",
  },
  {
    title: "2025 UCAT",
    description:
      "Over 3,000 UCAT practice questions covering the VR, DM, QR and SJ domains, including 3 full mock exams",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055905/image9_qb7cpp.jpg",
  },
  {
    title: "Pharmacy Registration Assessment",
    description:
      "Aligned with the revised GPhC assessment, our powerful knowledge tutor technology drills key exam facts into your memory",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055909/image10_ypx0qj.jpg",
  },
  {
    title: "MRCEM",
    description:
      "For the MRCEM primary and MRCEM intermediate we recommend FRCEMtutor. Please use the buttons below to find out more",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055891/image11_dltzqq.jpg",
    isExternal: true,
  },
  {
    title: "MRCOG",
    description:
      "PassMRCOG is a specialist website which provides revision for the MRCOG Part 1 & 2. Please use the buttons below to find out more",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055892/image12_fnsnmr.jpg",
    isExternal: true,
  },
  {
    title: "Paediatrics",
    description:
      "We recommend the specialist website PassPaeds for both the DCH and MRCPCH revision. Please use the buttons below to find out more",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055918/image13_qgs7s4.jpg",
    isExternal: true,
  },
  {
    title: "MRCPsych",
    description:
      "MRCPsychMentor is a specialist MRCPsych website that provides revision for all three papers. Please use the buttons below to find out more",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055893/image14_zkck8z.jpg",
    isExternal: true,
  },
  {
    title: "MRCS",
    description:
      "We recommend the specialist website eMRCS for both Part A & B MRCS revision. Please use the buttons below to find out more",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055912/image15_liacli.jpg",
    isExternal: true,
  },
  {
    title: "USMLE Step 1",
    description:
      "Over 3,000 USMLE Step 1 SBAs + thousands of USMLE Step 1 flashcards, powered by our spaced repetition algorithm",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055910/image16_nczdij.jpg",
  },
  {
    title: "FRCOphth Part 1",
    description:
      "eFRCOphth is a new website offering specialist revision for the FRCOphth Part 1",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055916/image17_a7njlw.jpg",
    isExternal: true,
  },
  {
    title: "Situational Judgement Test",
    description: "Over 240 questions for the F2 Situational Judgement Test",
    imageUrl:
      "https://res.cloudinary.com/dqn29bh2y/image/upload/v1747055917/image18_q7cmw6.jpg",
  },
];

// Main component that displays multiple cards in a grid
const MedicalExamPrepsGrid = () => {
  // Set up responsive grid behavior using React hooks
  const [columnCount, setColumnCount] = React.useState(3);

  React.useEffect(() => {
    // Function to adjust columns based on screen width
    const adjustGridColumns = () => {
      if (window.innerWidth < 600) {
        setColumnCount(1); // Mobile: 1 column
      } else if (window.innerWidth < 900) {
        setColumnCount(2); // Tablet: 2 columns
      } else {
        setColumnCount(3); // Desktop: 3 columns
      }
    };

    // Set initial column count
    adjustGridColumns();

    // Add event listener for window resize
    window.addEventListener("resize", adjustGridColumns);

    // Clean up
    return () => window.removeEventListener("resize", adjustGridColumns);
  }, []);
  const styles = {
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "20px",
      fontFamily: "Arial, sans-serif",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#111",
      marginBottom: "24px",
      textAlign: "center",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
      gap: "20px",
    },
    // Media queries are applied via React's useEffect and window.matchMedia
    // since inline styles don't support media queries directly
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Medical Exam Preparation Resources</h1>

      <div style={styles.grid}>
        {coursesData.map((course, index) => (
          <LandingPageCard
            key={index}
            title={course.title}
            description={course.description}
            imageUrl={course.imageUrl}
            isExternal={course.isExternal}
          />
        ))}
      </div>
    </div>
  );
};

export default MedicalExamPrepsGrid;
